import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";

type ManagerDicePopupProps = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export function ManagerDicePopup({
	open,
	onClose,
	onConfirm,
}: ManagerDicePopupProps) {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="confirm-dialog-title"
			aria-describedby="confirm-dialog-description"
		>
			<DialogTitle id="confirm-dialog-title">Assign managers</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-dialog-description">
					Are you sure you want to assign managers randomly?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color="inherit">
					Cancel
				</Button>
				<Button
					onClick={onConfirm}
					color="primary"
					variant="contained"
					autoFocus
				>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
}
